export enum PeriodType {
	HALF = "HALF",
	OT = "OT",
	PEN = "PEN",
}
